<template>
  <transition name="scaleDown">
    <div v-if="currentStudentDetail && Object.keys(currentStudentDetail).length > 0" class="sub-info student-detail-section">
      <transition v-if="loadingDetails" name="fade">
        <div class="container-loading-no-sidebar">
          <div class="loading">
            <div class="loader"/>
          </div>
        </div>
      </transition>
      <transition name="fade" mode="out-in">
        <div v-if="currentStudentDetail && !loadingDetails">
          <div class="missions-row">
            <div class="mission-count">
              <span class="count-title">TOTAL MISSIONS</span>
              <span class="count-value">{{ currentStudentDetail.countJobsDone }}</span>
            </div>
            <div class="mission-count">
              <span class="count-title">MISSIONS {{ currentClient }}</span>
              <span class="count-value">{{ currentStudentDetail.jobCountForCurrentCustomer }}</span>
            </div>
          </div>

          <ul class="detail-list">
            <li v-if="currentStudentDetail.email"><i class="fa fa-envelope" aria-hidden="true"/>
              <div class="text">
                {{ currentStudentDetail.email }}
              </div>
              <span class="span">Email</span>
            </li>
            <li v-if="currentStudentDetail.phone"><i class="fa fa-phone" aria-hidden="true"/>
              <div class="text">
                {{ currentStudentDetail.phone }}
              </div>
              <span class="span">Téléphone</span>
            </li>
            <li v-if="currentStudentDetail.studies || currentStudentDetail.school">
              <i class="fa fa-pencil" aria-hidden="true"/>
              <div class="text">
                <span v-if="currentStudentDetail.studies">{{ currentStudentDetail.studies }}</span>
                <span v-if="currentStudentDetail.school">{{ currentStudentDetail.school }}</span>
              </div>
              <span class="span">Mes études</span>
            </li>
            <li v-if="currentStudentDetail.commentUnique" class="font-italic">
              <i class="fa fa-star" aria-hidden="true"/>
              <div class="text">
                {{ currentStudentDetail.commentUnique }}
              </div>
              <span class="span">Ce qui me rend unique</span>
            </li>
            <li
              v-if="currentStudentDetail.threeAdjectives && currentStudentDetail.threeAdjectives.length !== 0 && (currentStudentDetail.threeAdjectives[0] || currentStudentDetail.threeAdjectives[1] || currentStudentDetail.threeAdjectives[2])"
              class="font-italic"
            >
              <IconUserBadge />
              <div class="text">
                <span v-if="currentStudentDetail.threeAdjectives[0] ">{{ currentStudentDetail.threeAdjectives[0] }}
                  <span v-if="currentStudentDetail.threeAdjectives[1]">, </span>
                </span>
                <span v-if="currentStudentDetail.threeAdjectives[1]"> {{ currentStudentDetail.threeAdjectives[1] }}</span>
                <span v-if="currentStudentDetail.threeAdjectives[2]">et </span>
                <span>{{ currentStudentDetail.threeAdjectives[2] }}</span>
              </div>
              <span class="span">Je me définis comme</span>
            </li>
            <li v-if="currentStudentDetail.geoPools && Object.keys(currentStudentDetail.geoPools).length > 0">
              <IconLocation />
              <div class="geopools">
                <span
                  v-for="(geopool, index) in currentStudentDetail.geoPools"
                  :key="index"
                  :class="currentStudentDetail.geoPools.length === index+1 ? 'geopool geopool-last' : 'geopool'"
                >{{ geopool.name }}
                </span>
              </div>
              <span class="span">Localisation</span>
            </li>

          </ul>
        </div>
      </transition>
    </div>
  </transition>
</template>

<script>

import IconLocation from '@/assets/icons/location.svg?component';
import IconUserBadge from '@/assets/icons/user-badge.svg?component';

export default {
  name: 'StudentModalDetails',
  components: { IconLocation, IconUserBadge },
  props: ['currentStudentDetail', 'loadingDetails', 'currentClient'],
  mounted() {
  },
  methods: {
  },
};
</script>

<style scoped>

</style>
